import React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../services/translate';
import MyAppText from './MyAppText';

interface Props {
    message?: string;
    style?: StyleProp<ViewStyle>;
}

export default function ErrorMessage({ message, style }: Props) {
    const { styles, theme } = useStyles(styleSheet);

    if (!message) {
        return null;
    }

    return (
        <View style={[styles.container, style]}>
            <FontAwesomeIcon icon={faCircleExclamation} color={theme.colors.errors['300']} fontSize={16} />
            <View style={styles.textContainer}>
                <MyAppText style={styles.text}>{message}</MyAppText>
                <MyAppText style={styles.subText}>{translate('contactAdministrator')}</MyAppText>
            </View>
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        backgroundColor: theme.colors.backgrounds['BG-5'],
        borderRadius: 4,
        paddingVertical: 10,
        paddingHorizontal: 12,
    },
    textContainer: {
        flex: 1,
        flexDirection: 'column',
        gap: 2,
    },
    text: {
        color: theme.colors.errors['300'],
        fontSize: 14,
        fontWeight: '500',
    },
    subText: {
        color: theme.colors.errors['300'],
        fontSize: 14,
        fontWeight: '400',
    },
}));
